import { render, staticRenderFns } from "./PopUpRipetizione.vue?vue&type=template&id=7f4bd3aa&"
import script from "./PopUpRipetizione.vue?vue&type=script&lang=js&"
export * from "./PopUpRipetizione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports